// Labels and defaults ported from models/save_options.py and models/texture_replace_options.py.

export const PACKER_LABELS = [
  ["None", "none"],
  ["LZ4", "lz4"],
  ["LZ4HC", "lz4hc"],
  ["LZMA", "lzma"],
  ["Original", "original"],
];
export const RESOURCE_LABELS = [
  ["Inline", "inline"],
  ["Orphan cleanup", "orphan_cleanup"],
  ["Rebuild .resS", "resource_patch"],
];
export const CRC_LABELS = [
  ["Off", "off"],
  ["On", "on"],
  ["Auto", "auto"],
];

export const OPTION_LABELS = {
  packer: PACKER_LABELS,
  resource_patch_mode: RESOURCE_LABELS,
  crc_mode: CRC_LABELS,
};

export const SAVE_OPTION_HELP = {
  packer:
    "Select how to compress the bundle.\n - None: no compression.\n - LZ4: fast compression but larger size.\n - LZ4HC: better compression than LZ4.\n - LZMA: best compression but slowest.\n - Original: keeps the bundle's current compression flags.",
  resource_patch_mode:
    "Select how to patch the resource stream.\n - Inline: stores resource data in the object.\n - Orphan cleanup: drops unused .resS entries.\n - Rebuild .resS: writes resource data back into .resS.",
  crc_mode: "Makes the CRC32 the same as the original file.\n - Auto: detects from the BuildTarget if it is Windows",
};

export const DEFAULT_SETTINGS = {
  show_all: false,
  packer: "original",
  resource_patch_mode: "resource_patch",
  crc_mode: "auto",
  save_options_expanded: true,
  show_only_changed_files: true,
  always_show_texture_options: false,
  left_width: null,
};

export const DESTINATION_FORMAT_LABEL = "Use destination format";
export const TEXTURE_FORMAT_CHOICES = [
  [DESTINATION_FORMAT_LABEL, null],
  ["Alpha8", 1],
  ["RGB24", 3],
  ["RGBA32", 4],
  ["ARGB32", 5],
  ["BGRA32", 14],
  ["DXT1", 10],
  ["DXT5", 12],
  ["BC4", 26],
  ["BC5", 27],
  ["BC7", 25],
  ["ETC2_RGB", 45],
  ["ETC2_RGBA8", 47],
  ["ASTC_RGB_4x4", 48],
  ["ASTC_RGB_5x5", 49],
  ["ASTC_RGB_6x6", 50],
  ["ASTC_RGB_8x8", 51],
  ["ASTC_RGB_10x10", 52],
  ["ASTC_RGB_12x12", 53],
  ["ASTC_RGBA_4x4", 54],
  ["ASTC_RGBA_5x5", 55],
  ["ASTC_RGBA_6x6", 56],
  ["ASTC_RGBA_8x8", 57],
  ["ASTC_RGBA_10x10", 58],
  ["ASTC_RGBA_12x12", 59],
];
export const FILTER_MODE_LABELS = ["Point", "Bilinear", "Trilinear"];
export const WRAP_MODE_LABELS = ["Repeat", "Clamp", "Mirror", "MirrorOnce"];
export const COLOR_SPACE_LABELS = ["Gamma", "Linear"];

export const OPEN_SUFFIXES = [".bundle", ".unity3d"];
export const TEXTURE_REPLACE_SUFFIXES = [".png", ".jpg", ".jpeg", ".bmp", ".tga", ".dds"];
// Listed by default: the types the preview can show. Options > Display all
// assets lists the others too (AssetBundle, MonoBehaviour, GameObject, ...).
export const AVAILABLE_TYPES = ["Texture2D", "TextAsset", "Sprite", "SpriteAtlas", "AudioClip", "Mesh"];
export const OPEN_FOLDER_CONFIRM_AFTER = 100;
